export default {
  lineNumberColor: `#e0e2e4`,
  lineNumberBgColor: `#282b2e`,
  backgroundColor: `#282b2e`,
  textColor: `#e0e2e4`,
  substringColor: `#8cbbad`,
  keywordColor: `#93c763`,
  attributeColor: `#668bb0`,
  selectorAttributeColor: `#93c763`,
  docTagColor: undefined,
  nameColor: `#8cbbad`,
  builtInColor: `#8cbbad`,
  literalColor: `#93c763`,
  bulletColor: `#8cbbad`,
  codeColor: `white`,
  additionColor: `#8cbbad`,
  regexpColor: `#d39745`,
  symbolColor: `#ec7600`,
  variableColor: `#8cbbad`,
  templateVariableColor: `#8cbbad`,
  linkColor: `#d39745`,
  selectorClassColor: `#A082BD`,
  typeColor: `#8cbbad`,
  stringColor: `#ec7600`,
  selectorIdColor: `#93c763`,
  quoteColor: `#818e96`,
  templateTagColor: `#8cbbad`,
  deletionColor: `#818e96`,
  titleColor: undefined,
  sectionColor: `white`,
  commentColor: `#818e96`,
  metaKeywordColor: `#e0e2e4`,
  metaColor: `#557182`,
  functionColor: `#e0e2e4`,
  numberColor: `#ffcd22`,
}
